import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class JobService {
    static findSubmissionsByCreateUser(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'findSubmissionsByCreateUser',
            [],
            additionalHeaders
        );
    }

    static findSubmissionByCreateUserOpenedWithinNumberOfDays(
        numberOfDays,
        additionalHeaders
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'findSubmissionByCreateUserOpenedWithinNumberOfDays',
            [numberOfDays],
            additionalHeaders
        );
    }

    static findSubmissionsByAccount(accountNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'findSubmissionsByAccount',
            [accountNumber],
            additionalHeaders
        );
    }

    static findJobByJobNumber(jobNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'findJobByJobNumber',
            [jobNumber],
            additionalHeaders
        );
    }

    static withdrawJobByJobNumber(jobNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'withdrawJobByJobNumber',
            [jobNumber],
            additionalHeaders
        );
    }

    static getOpenJobsByJobTypeForCurrentUser(jobType, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'getOpenJobsByJobTypeForCurrentUser',
            [jobType],
            additionalHeaders
        );
    }

    static jobsByTypeForCurrentUser(
            producerCode, lastXDays, jobType, status, lobs, start, end, additionalHeaders = {}) {
        lobs = _.isEmpty(lobs) ? null : lobs;
        const params = [producerCode, lastXDays, jobType, status, lobs, start, end];
        const service = getProxiedServiceUrl('gatewaySubmission');
        return JsonRPCService.send(service, 'jobsByTypeForCurrentUser', params, additionalHeaders);
    }

    static getRequalificationJobCount(producerCode, updatedInLastXDays, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'getRequalificationJobCount',
            [producerCode, updatedInLastXDays],
            additionalHeaders
        );
    }

    static requalificationJobsForCurrentUser(
            producerCode, updatedInLastXDays, start, end, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'requalificationJobsForCurrentUser',
            [producerCode, updatedInLastXDays,start, end],
            additionalHeaders
        );
    }

}
